/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header__LoginInputs */

const en_header__login = /** @type {(inputs: Header__LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Header__LoginInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header__login = /** @type {((inputs?: Header__LoginInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header__LoginInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header__login(inputs)
});